<div id="banner-portada">
  <div class="row gx-0">
    <div id="swiper-portada" class="col-12">
      <div class="swiper swiperPortada">
        <div class="swiper-wrapper">
          <!--#region SEGOFINANCE, OtrosProductos -->
          @if (plataformaId === 'SEGOFINANCE') {
          <div class="swiper-slide">
            <app-banner-segofinance></app-banner-segofinance>
          </div>
          <div class="swiper-slide">
            <app-banner-funds-depositos [domainUrl]="domainUrlFunds"
              [plataformaId]="plataformaId"></app-banner-funds-depositos>
          </div>
          <div class="swiper-slide">
            <app-banner-sego-blog></app-banner-sego-blog>
          </div>
          }
          <!-- #endregion -->

          <!--#region ProductosCNMV -->
          @if (plataformaId === 'VENTURE' || plataformaId === 'REALESTATE' || plataformaId === 'CREATIVE') {
            <div class="swiper-slide">
              <app-banner-venture-drimer [domainUrl]="domainUrlVenture" [domainVentureUrl]="domainUrlVenture"
                [plataformaId]="plataformaId"></app-banner-venture-drimer>
            </div>
          <div class="swiper-slide">
            <app-banner-barrons-cove [domainUrl]="domainUrlCreative" [plataformaId]="plataformaId"></app-banner-barrons-cove>
          </div>
          }
          <!-- #endregion -->

          <!--#region FACTORING -->
          @if (plataformaId === 'FACTORING') {
          <div class="swiper-slide">
            <app-banner-factoring-nuevo></app-banner-factoring-nuevo>
          </div>
          <div class="swiper-slide">
            <app-banner-autoinvest></app-banner-autoinvest>
          </div>
          <div class="swiper-slide">
            <app-banner-calculadora></app-banner-calculadora>
          </div>
          }
          <!-- #endregion -->

          <!--#region FUNDS -->
          @if (plataformaId === 'FUNDS') {
          <div class="swiper-slide">
            <app-banner-funds-cripto></app-banner-funds-cripto>
          </div>
          <div class="swiper-slide">
            <app-banner-funds-depositos [domainUrl]="domainUrlFunds"
              [plataformaId]="plataformaId"></app-banner-funds-depositos>
          </div>
          <div class="swiper-slide">
            <app-banner-funds-cta-corriente [domainUrl]="domainUrlFunds"></app-banner-funds-cta-corriente>
          </div>
          <div class="swiper-slide">
            <app-banner-funds-tematicas></app-banner-funds-tematicas>
          </div>
          }
          <!-- #endregion -->
        </div>
        <div id="pagination">
          <div class="swiper-pagination swiper-pagination-portada mb-3"></div>
        </div>
      </div>
    </div>
  </div>
</div>